import React, { PropsWithChildren } from 'react';
import { Box, Text, TextProps } from '/src/components';

export const DataTableHeader: React.FC<DataTableHeaderProps> = ({ children, title, border, subText, ...textProps }) => (
  <Box
    direction="row"
    gap="xsmall"
    border={border ? { color: 'transparent', size: 'small' } : undefined}
    pad={{ vertical: '1rem' }}
  >
    <Text size="small" color="dark-1" toUpperCase {...textProps}>
      {children ?? title}
    </Text>
    {subText && (
      <Text size="xsmall" color="dark-4">
        {subText}
      </Text>
    )}
  </Box>
);

export type DataTableHeaderProps = PropsWithChildren &
  TextProps & {
    title?: string;
    border?: boolean;
    subText?: string;
  };
